var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-contact-consent',_vm._b({model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'n-contact-consent',_vm.schema,false))
}
var staticRenderFns = []

export { render, staticRenderFns }